import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import FirebaseRemote from '../../firebaseRemote';

import Input from '../../components/form/input';

import localUtil from '../../lib/util';

@observer
class ShotTrainerFieldRemote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            showAll: 'shownew',
            soundOn: false,
            newssLength: 0,
            firebaseReceiverSessionId: `${Math.floor(Math.random() * 9000) + 1000}`,
        };
        this.mainContainer = null;
        this.reloadTimer = null;

        this.firebaseRemote = null;//  = new FirebaseRemote(this.state.firebaseReceiverSessionId);
    }

    updateFirebaseRemoteSessionId = (e) => {
        const { name, value } = e.target;
        const { shotTrainerStore } = this.props.stores;
        shotTrainerStore.updateKeyValue('firebaseRemoteSessionId', value);
        this.firebaseRemote = new FirebaseRemote(value);
    }

    firebaseGetReadyForShooting = async () => {
        const result = await this.firebaseRemote.sendCommand('getReadyForShooting', {});
        console.log('firebaseGetReadyForShooting', result);
        this.setState({ firebaseGetReadyForShooting: result });
    }
    firebaseStartExercise = async () => {
        const result = this.firebaseRemote.sendCommand('startExercise', {});
        console.log('firebaseStartExercise', result);
        this.setState({ firebaseStartExercise: result });
    }
    firebaseStopExercise = async () => {
        const result = this.firebaseRemote.sendCommand('stopExercise', {});
        console.log('firebaseStopExercise', result);
        this.setState({ firebaseStopExercise: result });
    }
    firebaseEmptyGunInspectEachOther = async () => {
        const result = this.firebaseRemote.sendCommand('emptyGunInspectEachOther', {});
        console.log('firebaseEmptyGunInspectEachOther', result);
        this.setState({ firebaseEmptyGunInspectEachOther: result });
    }
    firebaseNotReady = async () => {
        const result = this.firebaseRemote.sendCommand('notReady', {});
        console.log('firebaseNotReady', result);
        this.setState({ firebaseNotReady: result });
    }
    firebaseFinishExercise = async () => {
        const result = this.firebaseRemote.sendCommand('finishExercise', {});
        console.log('firebaseFinishExercise', result);
        this.setState({
            firebaseGetReadyForShooting: null,
            firebaseStartExercise: null,
            firebaseStopExercise: null,
            firebaseEmptyGunInspectEachOther: null,
            firebaseNotReady: null,
            firebaseFinishExercise: null,
        });
    }

    render() {
        const {
            firebaseGetReadyForShooting,
            firebaseStartExercise,
            firebaseStopExercise,
            firebaseEmptyGunInspectEachOther,
            firebaseNotReady,
            firebaseFinishExercise,
        } = this.state;
        const {
            classNames = '',
        } = this.props;
        const { userStore, shotTrainerStore } = this.props.stores;
        const { user = {}, isAdmin, isTester, isVeterinary, isPremium } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { firebaseRemoteSessionId } = shotTrainerStore;

        return (<>
            {isAdmin && <>
                <div class={`w-100 d-flex flex-column justify-content-center ${classNames} mb-3 mt-3`}>
                    <div class='font-weight-lighter px-3 box-header text-danger'>
                        <Text id='shottrainer.field-remote-title'>Field shooting remote</Text>
                    </div>
                    <div class={`d-flex flex-column mx-3 px-3 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} border border-danger shadow`}>
                        <div class='d-flex flex-row flex-fill'>
                            <Input
                                stores={this.props.stores}
                                holdingStore={shotTrainerStore}
                                object={{}}
                                type='tel'
                                pattern='[0-9]*'
                                inputmode='numeric'
                                class='form-control'
                                field='firebaseRemoteSessionId'
                                placeholder={`Firebase session id`}
                                onInput={e => this.updateFirebaseRemoteSessionId(e)}
                                inputValue={firebaseRemoteSessionId}
                            />
                        </div>

                        {firebaseRemoteSessionId ? <>
                            <div
                                class='position-absolute bg-light px-2 py-1 w-100 border-top border-danger d-flex flex-wrap justify-content-center'
                                style='
                                    bottom: 0px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    font-size: 0.9rem;
                                    line-height: 1.0rem;
                                    cursor: pointer;
                                    box-shadow: 0px -2px 7px rgba(0, 0, 0, 0.2);
                                    z-index: 1000;
                                '
                            >
                                <button
                                    type='button'
                                    class={`btn btn-${firebaseGetReadyForShooting ? 'outline-' : ''}primary rounded-pill my-1 mx-1`}
                                    onClick={this.firebaseGetReadyForShooting}
                                >
                                    <i class='fa-duotone fa-gun mr-3' />
                                    1. <Text id='shottrainer.getReadyForShooting'>Get ready for shooting</Text>
                                </button>
                                <button
                                    type='button'
                                    class={`btn btn-${firebaseStartExercise ? 'outline-' : ''}primary rounded-pill my-1 mx-1`}
                                    onClick={this.firebaseStartExercise}
                                >
                                    <i class='fa-duotone fa-play mr-3' />
                                    2. <Text id='shottrainer.start'>Start</Text>
                                </button>
                                <button
                                    type='button'
                                    class={`btn btn-${firebaseEmptyGunInspectEachOther ? 'outline-' : ''}primary rounded-pill my-1 mx-1`}
                                    onClick={this.firebaseEmptyGunInspectEachOther}
                                >
                                    <i class='fa-duotone fa-hand mr-3' />
                                    3. <Text id='shottrainer.empty-gun-inspect-each-other'>Empty gun and inspect</Text>
                                </button>
                                <button
                                    type='button'
                                    class={`btn btn-${firebaseFinishExercise ? 'outline-' : ''}success rounded-pill my-1 mx-1`}
                                    onClick={this.firebaseFinishExercise}
                                >
                                    <i class='fa-duotone fa-refresh mr-3' />
                                    4. <Text id='shottrainer.finish'>Finish</Text>
                                </button>

                                <div class='w-100 d-flex flex-row justify-content-center'>
                                    <button
                                        type='button'
                                        class={`btn btn-${firebaseStopExercise ? 'outline-' : ''}danger rounded-pill my-1 mx-1`}
                                        onClick={this.firebaseStopExercise}
                                    >
                                        <i class='fa-duotone fa-stop mr-3' />
                                        <Text id='shottrainer.stop'>Stop</Text>
                                    </button>
                                    <button
                                        type='button'
                                        class={`btn btn-${firebaseNotReady ? 'outline-' : ''}warning rounded-pill my-1 mx-1`}
                                        onClick={this.firebaseNotReady}
                                    >
                                        <i class='fa-duotone fa-hourglass-half mr-3' />
                                        <Text id='shottrainer.notReady'>Not ready</Text>
                                    </button>
                                </div>
                            </div>
                        </> : <>


                        </>}
                    </div>




                </div>
            </>}

        </>);
    }
}

export default ShotTrainerFieldRemote;
